import { FacilityVersion } from './FacilityVersion';

export default FacilityVersion;
